import { ChevronRight } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { isMiniApp } from './platform';

export function ConsultationEntry() {
  const navigate = useNavigate();
  const content = <><span><strong>Đăng ký tìm hiểu tuyển sinh</strong><small>Thông tin tuyển sinh năm 2027 dành cho bạn</small></span><ChevronRight size={20} aria-hidden="true" /></>;
  if (!isMiniApp()) return <Link className="consultation-entry" to="/consultation">{content}</Link>;
  // Use the working native button activation path; no anchor/default browser
  // navigation, touch-start navigation or SDK call is needed to open this form.
  return <button type="button" className="consultation-entry" onClick={() => {
    if (import.meta.env.VITE_ZALO_DIAGNOSTICS === 'true')
      console.info('[hcmulaw:navigation]', { event: 'consultation-activate' });
    navigate('/consultation');
  }}>{content}</button>;
}
